import React, { useState, useEffect } from "react";
import PersonalInformationForm from "./PersonalInformationForm";
import AddressInformation from "./AddressInformation";
import { updateState, states } from "../StateManagement";
import { useTranslation } from "react-i18next";

interface IProps {
    manage: any;
    displayData: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
}

const PersonalInformation = ({ manage, displayData, registrationState, setRegistrationState, registrationLookup }: IProps) => {
    const isBusinessUser = displayData && displayData.isBusinessUser;
    const [form, setForm] = useState(registrationState.addressInfo && registrationState.addressInfo.formOne === false ? false : true);
    const { t: tLang } = useTranslation();

    useEffect(() => {
        if (isBusinessUser) {
            <h2 className="box-title">{tLang("registration.tabs.contact")}</h2>;
            manage(updateState(states, displayData.billingRequired, 1));
        }
    }, []);

    return (
        <div>
            {form ? (
                <PersonalInformationForm
                    manage={manage}
                    registrationLookup={registrationLookup}
                    setForm={setForm}
                    displayData={displayData}
                    registrationState={registrationState}
                    setRegistrationState={setRegistrationState}
                />
            ) : (
                <AddressInformation
                    registrationLookup={registrationLookup}
                    setForm={setForm}
                    manageState={manage}
                    displayData={displayData}
                    registrationState={registrationState}
                    setRegistrationState={setRegistrationState}
                />
            )}
        </div>
    );
};

export default PersonalInformation;
